let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("q3l0L")).then(() => parcelRequire('dlQ8N'));